export type Recommendation = {
    brandName: string;
    image: {
        _links: {
            external: {
                href: string;
            };
        };
    };
    meta: {
        product_VariationId: string;
    };
    tracking: {
        variationId: string;
    };
    formattedPrice: FormattedPrice;
    _embedded: {
        ['o:variation']: {
            name: string;
            averageRatingRounded: number;
            numberOfReviews: number;
            _links: {
                ['o:image']: {
                    href: string;
                };
                ['o:detail-view']: {
                    href: string;
                };
            };
            energyEfficiencyClasses?: EnergyEfficiency[];
        };
    };
};

export type RecommendationResponse = {
    recommendations: Recommendation[];
};

export type Alternative = {
    name: string;
    brandName: string;
    id: string;
    averageRatingRounded: number;
    numberOfReviews: number;
    image: string;
    link: string;
    formattedPrice: FormattedPrice;
    energyEfficiencyClasses?: EnergyEfficiency[];
};

export type FormattedPrice = {
    originalPrice?: string;
    originalPricePrefix?: string;
    retailPrice: string;
    unitPrice?: string;
};

export type EnergyEfficiency = {
    category: string;
    color: string;
    colorHexCode: string;
    component: string;
    dataSheetHref: string;
    modelName: string;
    uniform: boolean;
};

export type Star = 'filled' | 'half' | 'empty';

export enum Topics {
    SPONSORED_CONTENT_ALTERNATIVE_READY = 'ft5.sponsored-content-alternative.ready',
    SPONSORED_CONTENT_ALTERNATIVE_FAILED = 'ft5.sponsored-content-alternative.failed',
    SPONSORED_CONTENT_ALTERNATIVE_REVEAL = 'ft5.sponsored-content-alternative.reveal',
}
